import React, { useEffect } from 'react'
import { HelmetProvider } from "react-helmet-async"
import { AllBrands, BrandDetails, CategoryDetails, Checkout, Favourites, ForgotPassword, Home, Orders, ProductDetails, ResetPassword, SearchLarge, SearchSmall, ShoppingCart, SignIn, SignUp, SuccessPassword } from './pages'
import { PrivacyPolicy } from './pages'
import { AboutUs, ContactUs, Careers, ImportantLinks, FAQ, Refunds, Payments, Rewards, Profile, ThankYou } from './pages/static'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { Header, MobileHeader, Footer, PublicRoute, ProtectedRoute, ScrollToTop } from './components'
import { useDeviceType } from './constant'
import { useSelector } from 'react-redux'

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const AppContent = () => {
  const { token, userDetails } = useSelector((state) => state.user);
  const { isDesktop, isTablet, isMobile } = useDeviceType();
  const location = useLocation();

  // Define routes that shouldn't display the Header or MobileHeader
  const noHeaderRoutes = [
    '/login', '/signup', '/forgot-password', '/reset-password', '/success-password',
    '/checkout'
  ];
  const hideScreen = noHeaderRoutes.includes(location.pathname);

  const mainStyle = hideScreen ? {} : (isDesktop ? { paddingTop: '50px' } : { paddingTop: '20px' });

  useEffect(() => {
    const setUserId = async () => {
      try {
        if (token && userDetails?.id) {
          // Store user ID if token and userDetails exist
          await localStorage.setItem('user_id', userDetails.id.toString());
          // Also ensure token is in localStorage for axios interceptor
          await localStorage.setItem('token', token);
        } else {
          // Generate and store a guest ID if token is missing
          const storedUserId = `guest-${Math.random().toString(36).substr(2, 9)}`;
          await localStorage.setItem('user_id', storedUserId);
          // Clear token if no valid session
          await localStorage.removeItem('token');
        }
      } catch (error) {
        console.error('Error setting user_id in AsyncStorage:', error);
      }
    };
    setUserId();

  }, [token, userDetails]); // Runs whenever token or userDetails change

  return (
    <>
      {!hideScreen && (
        <>
          {isDesktop && <Header />}
          {isTablet && <MobileHeader />}
        </>
      )}
      <main style={mainStyle}>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/search' element={!isMobile ? <SearchLarge /> : <SearchSmall /> }  />
          <Route path='/product/:slug' element={<ProductDetails />} />
          <Route path='/brand/:slug' element={<BrandDetails />} />
          <Route path='/category/:slug' element={<CategoryDetails />} />
          <Route path='/brands' element={<AllBrands />} />
          {/* Public Routes */}
          <Route path="/login" element={<PublicRoute><SignIn /></PublicRoute>} />
          <Route path="/signup" element={<PublicRoute><SignUp /></PublicRoute>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/success-password" element={<SuccessPassword />} />
          {/* Protected Routes */}
          <Route path="/cart" element={<ProtectedRoute><ShoppingCart /></ProtectedRoute>} />
          <Route path="/favourites" element={<ProtectedRoute><Favourites /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
          <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
          {/* Static Pages */}
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/important-links" element={<ImportantLinks />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/refunds" element={<Refunds />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </main>
      {!hideScreen && (
        <>
          <Footer />
        </>
      )}
      <ToastContainer />
    </>
  );
};

const App = () => (
  <HelmetProvider>
    <Router basename='/'>
      <ScrollToTop />
      <AppContent />
    </Router>
  </HelmetProvider>
);

export default App